import { OrderAdjustmentsOrder } from 'pages/OrderAdjustments/types';
import { useListContext } from 'react-admin';

export function useSelectedOrders(): OrderAdjustmentsOrder[] {
  const { data: orders, selectedIds } = useListContext<OrderAdjustmentsOrder>();

  return orders?.filter((order) => selectedIds?.some((id) => order.id === id)) || [];
}
